var React = require('react');

function HudlChevron (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.00247 7.41999L0.219971 1.64499L1.28497 0.579987L6.00247 5.30499L10.72 0.579987L11.785 1.64499L6.00247 7.41999Z","fill":"currentColor"}));
}

HudlChevron.defaultProps = {"width":"12","height":"8","viewBox":"0 0 12 8","fill":"none"};

module.exports = HudlChevron;

HudlChevron.default = HudlChevron;
